export const locale = {
  lang: 'es',
  data: {
    'CHANGELOG': {
      'TITULO': 'Registro de cambios',
      'SUBTITULO': 'Consulte las actualizaciones realizadas a la plataforma a lo largo del tiempo',
      'ULTIMA': 'Última actualización',
      'CATEGORIAS': {
        'Changed': 'Cambios',
        'Fixed': 'Arreglos',
        'Added': 'Mejoras'
      }
    },
    'KNOWLEDGE': {
      'LINK': 'Haga clic en este enlace si la plataforma no lo redirige automáticamente'
    }
  }
};
